import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import './style.scss';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound__container">
      <span className="notfound__number">404</span>
      <span className="notfound__title">Page not found</span>
      <span className="notfound__subtitle">Oops!, the page you looking for does not exist</span>

      <Button className="notfound__button" onClick={() => navigate('/')}>
        Back to home
      </Button>
    </div>
  );
};

export default NotFound;
